import React from 'react';
import { IExternalLinkItemProps } from '../../interfaces/ExternalLinkProps';

/**
 * A component to show a single link to an external website with icon
 * @param externalLink
 * @constructor
 */
const ExternalLinkItem = ({ externalLink }: IExternalLinkItemProps):JSX.Element | null => {
  if (externalLink) {
    return (
      <a target="_blank" href={externalLink} rel="noreferrer">
        {externalLink}
        <span className="fa-ext extlink"><span className="ext" aria-label="  (externe link)" /></span>
        <span className="element-invisible sr-only newwindow">  (opent in een nieuw venster)</span>
      </a>
    );
  }

  return null;
};

export default ExternalLinkItem;
